import React from 'react';
import { useNavigate } from 'react-router-dom';
import PanchTatvaButton from '../components/PanchTatvaButton';

const topics = [
  {
    icon: '📦',
    title: 'Track Your Order',
    description: 'View real-time status of your current and past orders.',
    action: '/orders',
    actionLabel: 'View Orders',
  },
  {
    icon: '↩️',
    title: 'Returns & Refunds',
    description: 'Understand our return window, eligibility, and refund process.',
    action: '/returns',
    actionLabel: 'Return Policy',
  },
  {
    icon: '🚚',
    title: 'Shipping Information',
    description: 'Learn about delivery timelines, charges, and coverage areas.',
    action: '/shipping',
    actionLabel: 'Shipping Policy',
  },
  {
    icon: '❓',
    title: 'Frequently Asked Questions',
    description: 'Quick answers to the most common questions about our products and services.',
    action: '/faq',
    actionLabel: 'Browse FAQs',
  },
  {
    icon: '✉️',
    title: 'Contact Support',
    description: 'Send us a message and our team will reply within 24 hours on business days.',
    action: '/contact',
    actionLabel: 'Contact Us',
  },
  {
    icon: '👤',
    title: 'Account & Profile',
    description: 'Manage your addresses, update your profile, or view your order history.',
    action: '/profile',
    actionLabel: 'My Profile',
  },
];

const steps = [
  { step: '1', title: 'Check the FAQs', desc: 'Most queries are answered there instantly.' },
  { step: '2', title: 'Browse Policies', desc: 'Review our Return, Shipping, and Privacy pages.' },
  { step: '3', title: 'Contact Us', desc: 'If still unresolved, send us an email or call.' },
  { step: '4', title: 'We Respond', desc: 'Our team replies within 24 hours on working days.' },
];

export default function HelpSupport() {
  const navigate = useNavigate();
  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 py-12 md:py-20">
      {/* Header */}
      <div className="text-center mb-10 md:mb-14">
        <p className="text-secondary font-medium tracking-widest text-xs md:text-sm uppercase mb-3">Support</p>
        <h1 className="text-3xl md:text-5xl font-heading text-headingText mb-4">Help & Support</h1>
        <p className="text-sm md:text-base text-bodyText opacity-80 max-w-xl mx-auto">
          We're here to help. Find the right resource below or reach out to our support team directly.
        </p>
      </div>

      {/* Topic Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-14">
        {topics.map((t) => (
          <div
            key={t.title}
            className="bg-cardBg rounded-2xl p-6 shadow-sm flex flex-col gap-3 hover:shadow-md transition"
          >
            <span className="text-3xl">{t.icon}</span>
            <h2 className="text-base md:text-lg font-heading text-headingText">{t.title}</h2>
            <p className="text-sm text-bodyText leading-relaxed flex-grow">{t.description}</p>
            <PanchTatvaButton
              onClick={() => navigate(t.action)}
              variant="outline"
              size="small"
            >
              {t.actionLabel} →
            </PanchTatvaButton>
          </div>
        ))}
      </div>

      {/* How it works */}
      <div className="bg-cardBg rounded-2xl p-6 md:p-10 mb-10">
        <h2 className="text-xl md:text-2xl font-heading text-headingText text-center mb-8">
          How to Get Help
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {steps.map((s) => (
            <div key={s.step} className="text-center">
              <div className="w-10 h-10 rounded-full bg-secondary text-surface font-bold text-lg flex items-center justify-center mx-auto mb-3">
                {s.step}
              </div>
              <h3 className="font-heading text-headingText text-sm md:text-base mb-1">{s.title}</h3>
              <p className="text-xs md:text-sm text-bodyText opacity-80">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Direct Contact CTA */}
      <div className="text-center bg-cardBg rounded-2xl p-8 md:p-10">
        <p className="text-xl md:text-2xl font-heading text-headingText mb-2">Still need help?</p>
        <p className="text-sm md:text-base text-bodyText mb-2">
          Email us at{' '}
          <a href="mailto:support@panch-tatva.co.in" className="text-secondary hover:underline">
            support@panch-tatva.co.in
          </a>
        </p>
        <p className="text-sm text-bodyText mb-6 opacity-70">
          Or call{' '}
          <a href="tel:+916390725752" className="text-secondary hover:underline">
            +91 6390725752
          </a>
          {' '}(Mon–Sat, 10 AM – 6 PM IST)
        </p>
        <PanchTatvaButton onClick={() => navigate('/contact')}>
          Contact Support Team
        </PanchTatvaButton>
      </div>

      <div className="mt-10 text-center">
        <PanchTatvaButton onClick={() => navigate(-1)} variant="outline">
          ← Go Back
        </PanchTatvaButton>
      </div>
    </div>
  );
}
